<template>

  <v-app-bar color="blue darken-4" fixed app clipped-right>
    <img src='images/banner.png' height='30'>
    <v-spacer></v-spacer>
      <!-- Mobile Menu -->
      <div class="text-center hidden-md-and-up pr-5">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
                  <v-icon
                      color="White"
                      dark
                      v-on="on">dehaze</v-icon>
                </template>
          <v-list>
            <v-list-item
                to='/'
            >
              <v-list-item-title >Home</v-list-item-title>
            </v-list-item>
            <v-list-item
              to='/features'
            >
              <v-list-item-title >Features</v-list-item-title>
            </v-list-item>
            <v-list-item
                         to='/order'
                        >
              <v-list-item-title >Pricing</v-list-item-title>
            </v-list-item>
            <v-list-item
                         to='/contact'
                        >
              <v-list-item-title >Contact</v-list-item-title>
            </v-list-item>
            <v-list-item
                         href='https://www.engagesms.net/app/'
                        >
              <v-list-item-title >Login</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <!-- End Mobile Menu -->
    <v-toolbar-items class="hidden-sm-and-down">
      <v-btn dark text to="/">Home</v-btn>
      <v-btn dark text to="/features">Features</v-btn>
      <v-btn dark text to="/order">Pricing</v-btn>
      <v-btn dark text to='/contact'>Contact</v-btn>
      <v-btn dark text href='https://www.engagesms.net/app/'>Login</v-btn>
    </v-toolbar-items>
  </v-app-bar>

</template>


<script>

  export default {
    data: () => ({
      items: [
                {
                  title: 'Home',
                  to:'/'
                },
                {
                  title: 'Features',
                  to:'/features'

                },
                {
                  title: 'Order',
                  to:'/order'
                },
                {
                  title: 'Contact',
                  to:'/contact'
                },
                {
                  title: 'Login',
                  to:'/app'
                }
              ]
    })
  }

</script>
